import { AccountStatus } from 'src/shared/types/common';

export const disabledByAccountStatus = <T extends { accountStatus: string }>(
  record: T,
) => record.accountStatus !== AccountStatus.FORCE_CHANGE_PASSWORD;
